export const LEAGUES = [
  { label: 'Premier League', id: 39 },
  { label: 'Serie A', id: 135 }
];

export const leagueIdByLabel = Object.fromEntries(
  LEAGUES.map((league) => [league.label, league.id])
);
